import { AssetParameter } from '../types/interfaces';

import { ObjectForSelectionTemplate } from './ObjectForSelectionTemplate';

export const ObjectCharacteristicTemplate: AssetParameter = {
  id: 0,
  name: '',
  measure: ObjectForSelectionTemplate,
  measureName: '',
  values: [],
  selectedValue: null
};
